import React from "react";
import styles from "./NotFound.module.scss";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <section className={styles.notFound}>
      <h2>404 - Stranica nije pronađena</h2>
      <p>Izgleda da ste se izgubili. Vratite se na <Link to="/">početnu stranicu</Link>.</p>
    </section>
  );
};

export default NotFound;